import type { ReportExport, ReportExportList } from '@jaf/contracts';
import { queryOptions } from '@tanstack/react-query';
import { fetchReportExports } from './report-exports-api';

/** Intervalo da consulta enquanto há exportação na fila ou sendo gerada. */
export const REPORT_EXPORTS_POLL_MS = 3000;

/** Fábrica de query keys das exportações (por organização). */
export const reportExportKeys = {
  all: (organizationId: string) => ['organizations', organizationId, 'report-exports'] as const,
};

/** Se a exportação ainda vai mudar de situação. */
export function isUnfinished(reportExport: Pick<ReportExport, 'status'>): boolean {
  return reportExport.status === 'PENDING' || reportExport.status === 'PROCESSING';
}

/**
 * Exportações recentes do usuário. Enquanto alguma estiver na fila ou sendo gerada, a lista é
 * consultada de novo a cada poucos segundos (é assim que o aviso de "pronto" chega à tela).
 */
export function reportExportsQuery(organizationId: string) {
  return queryOptions({
    queryKey: reportExportKeys.all(organizationId),
    queryFn: ({ signal }) => fetchReportExports(signal),
    refetchInterval: (query) => {
      const data: ReportExportList | undefined = query.state.data;
      return data?.items.some(isUnfinished) === true ? REPORT_EXPORTS_POLL_MS : false;
    },
  });
}
